import { createGlobalStyle } from "styled-components"

export const GlobalStyle = createGlobalStyle`

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
  font-size: 62.5%;

  @media (max-width: 1124px) {
    font-size: 56%;
  }

  @media (max-width: 425px) {
    font-size: 54%;
  }
}

  html,
  body {
    height: 100%;
  }

  body {
    font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-style: normal;
    font-size: 1.5rem;
    line-height: 1.6;
    color: #1f2933;
    background-color: #f7f5f0;
  }

  ul {
    list-style: none;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  a:hover {
    text-decoration: none;
  }

  .container {
    width: min(1120px, calc(100% - 48px));
    margin: 0 auto;

    @media (max-width: 1440px) {
      width: min(1060px, calc(100% - 44px));
    }
    @media (max-width: 761px) {
      width: min(100% - 32px, 720px);
    }
    @media (max-width: 426px) {
      width: min(100% - 28px, 420px);
    }
  }
`
